import { LitElement } from 'lit-element';
import {
  onHtmlDirChange,
  offHtmlDirChange,
  getHtmlDir,
} from '../../utils/rtl-utils';

/**
 * Our extension of LitElement. Fires an event when the component is connected,
 * and adds additional useful methods.
 */
export class KatLitElement extends LitElement {
  private _observers = [];

  connectedCallback() {
    window.dispatchEvent(
      new CustomEvent('katal-component-connected', {
        detail: { element: this },
      })
    );

    this.__updateRtl(getHtmlDir());
    onHtmlDirChange(this.__updateRtl);

    super.connectedCallback();
  }

  disconnectedCallback() {
    offHtmlDirChange(this.__updateRtl);
    super.disconnectedCallback();
  }

  dispatchCustomEvent<T extends {}>(
    eventType: string,
    detail?: T,
    bubbles = true
  ) {
    const evt = new CustomEvent(eventType, { bubbles, detail });
    this.dispatchEvent(evt);
  }

  observeChildren(
    parentElement: HTMLElement,
    callback: () => void
  ): MutationObserver {
    const observer = new MutationObserver(callback);
    observer.observe(parentElement, { childList: true });
    this._observers.push(observer);
    return observer;
  }

  __updateRtl = val => {
    if (!val) {
      this.removeAttribute('dir');
    } else {
      this.setAttribute('dir', val);
    }
  };
}
